<script lang="ts">
    import cn from '$common/utils/cn';
    import { ariaKeyDownA11yHandler } from '$common/utils/ariaKeyDownA11y';
    import { FilteredValues, OptionList } from '$saga/types/search.types';
    import CheckboxElement from '$saga/views/Search/common/CheckboxElement.svelte';

    export let options: OptionList;
    export let formValue: string[];

    let filteredOptions: FilteredValues | OptionList = options;

    const toggleCheckbox = (optionElement: {
        value: string;
        label: string;
    }) => {
        if (formValue.find((value) => value === optionElement.value)) {
            formValue = formValue.filter(
                (value) => value !== optionElement.value,
            );
        } else {
            formValue = [...formValue, optionElement.value];
        }
    };
</script>

{#if filteredOptions}
    {#each filteredOptions as optionElement}
        <div
            class={cn(
                'cursor-pointer leading-6 text-content-neutral hover:bg-commercial-neutral',
            )}
            role="button"
            tabindex="0"
            on:click={() => toggleCheckbox(optionElement)}
            {...ariaKeyDownA11yHandler(() => toggleCheckbox(optionElement))}
        >
            <CheckboxElement
                label={optionElement.label}
                labelClass={cn('mr-m')}
                isChecked={formValue.find(
                    (value) => value === optionElement.value,
                ) != null}
            />
        </div>
    {/each}
{/if}
